"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = __importDefault(require("gsap"));
const vs = `
  varying vec2 v_uv;
  void main() {
    v_uv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }`;
const fs = `
  precision mediump float;
  varying vec2 v_uv;
  uniform float u_opacity;
  uniform bool u_isWhite;
  uniform sampler2D u_texture;
  uniform vec3 fogColor;
  uniform float fogNear;
  uniform float fogFar;

  float map(float value, float min1, float max1, float min2, float max2) {
    return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
  }

  void main() {
    vec4 color = texture2D(u_texture, v_uv);
    color.a = map(color.a, 0.0, 1.0, 0.0, u_opacity);
    if (u_isWhite && color.a < u_opacity) {
      color.rgb = vec3(1.0);
    }
    gl_FragColor = color;

    #ifdef USE_FOG
      #ifdef USE_LOGDEPTHBUF_EXT
        float depth = gl_FragDepthEXT / gl_FragCoord.w;
      #else
        float depth = gl_FragCoord.z / gl_FragCoord.w;
      #endif
      float fogFactor = smoothstep( fogNear, fogFar, depth );
      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      //gl_FragColor = vec4(gl_FragCoord.z);
    #endif
  }
`;
class Text extends THREE.Object3D {
    constructor(width = 1, height = 1, texture, isWhite = false) {
        super();
        this.uniforms = {
            u_opacity: { value: 0.0 },
            u_texture: { value: texture },
            u_isWhite: { value: isWhite },
            fogColor: { type: 'c', value: new THREE.Color() },
            fogNear: { type: 'f', value: 0.0 },
            fogFar: { type: 'f', value: 0.0 },
        };
        this.width = width;
        this.height = height;
        this.shape = null;
        this.wireframe = null;
        this._createShape2();
    }
    fadeIn(time = 1) {
        gsap_1.default.killTweensOf(this.uniforms.u_opacity);
        gsap_1.default.to(this.uniforms.u_opacity, { duration: time, value: 1 });
    }
    fadeOut(time = 1) {
        gsap_1.default.killTweensOf(this.uniforms.u_opacity);
        gsap_1.default.to(this.uniforms.u_opacity, { duration: time, value: 0 });
    }
    setDepthTest(value) {
        if (this.shape)
            this.shape.material.depthTest = value;
    }
    _createShape2() {
        const geo = new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1);
        const mat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
            fog: true,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.add(this.shape);
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
}
exports.default = Text;
